import React from 'react';

import { BoldText, DangerText } from './Components/ContractText';

interface Props {
  offerGoodUntillDate?: string;
}

const DateTime = ({ offerGoodUntillDate }: Props) => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Date/Time is of the Essence
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside text-bold">
        <li>
          Written acceptance of all parties will be on or before{' '}
          {offerGoodUntillDate}.
        </li>
        <li>
          The Settlement Date and all other dates and times identified for the
          performance of any obligations of this Agreement are of the essence
          and are binding.
        </li>
        <li>
          The Execution Date of this Agreement is the date when Buyer and Seller
          have indicated full acceptance of this Agreement by signing it. For
          purposes of this Agreement, the number of days will be counted from
          the Execution Date, excluding the day this Agreement was executed and
          including the last day of the time period. All changes to this
          Agreement should be initialed and dated.
        </li>
        <li>
          The Settlement Date is not extended by any other provision of this
          Agreement and may only be extended by mutual written agreement of the
          parties.
        </li>
        <li>
          Certain terms and time periods are pre-printed in this Agreement as a
          convenience to the Buyer and Seller. All pre-printed terms and time
          periods are negotiable and may be changed by striking out the
          pre-printed text and inserting different terms acceptable to all
          parties, except where restricted by law.
        </li>
      </ol>
    </div>
  );
};

export default DateTime;
